import React, { useEffect, useState } from 'react';
import { Search, X as XIcon, Loader2, User, Clock, Users } from 'lucide-react';

const STATUS_CLS = { booked: 'bg-emerald-100 text-emerald-800', done: 'bg-blue-100 text-blue-800', cancelled: 'bg-red-100 text-red-800' };
const fmt = (d) => new Date(d + 'T00:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

export const BookingLine = ({ r }) => (
  <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs">
    <span className="inline-flex items-center gap-1 font-bold text-[color:var(--mv-navy)]"><Clock className="w-3 h-3" />{fmt(r.date)} · {r.time || '—'}{r.hours ? ` · ${r.hours}` : ''}</span>
    <span className={`inline-flex items-center gap-1 font-bold ${r.driver_name ? 'text-slate-700' : 'text-red-700'}`}><User className="w-3 h-3" />{r.driver_name || 'No driver yet'}</span>
    {r.porters?.length > 0 && <span className="inline-flex items-center gap-1 text-slate-600"><Users className="w-3 h-3" />{r.porters.join(', ')}</span>}
  </div>
);

export const BookingSearch = ({ authFetch, onPick }) => {
  const [q, setQ] = useState('');
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return undefined; }
    const t = setTimeout(() => {
      setBusy(true);
      authFetch('get', `/admin/bookings/search?q=${encodeURIComponent(q.trim())}`)
        .then(({ data }) => setRes(data.results)).catch(() => setRes([])).finally(() => setBusy(false));
    }, 300);
    return () => clearTimeout(t);
  }, [q, authFetch]);
  return (
    <div className="relative mb-4" data-testid="cal-search-wrap">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search bookings — name, phone, postcode, ref, email…" className="w-full h-11 pl-10 pr-10 rounded-xl border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--mv-orange)]" data-testid="cal-search" />
      {busy ? <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-slate-400" />
        : q && <button type="button" onClick={() => setQ('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" aria-label="Clear" data-testid="cal-search-clear"><XIcon className="w-4 h-4" /></button>}
      {res && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg z-30 max-h-96 overflow-y-auto" data-testid="cal-search-results">
          {res.length === 0 ? <div className="p-4 text-sm text-slate-500 text-center">No bookings match.</div> : res.map(r => (
            <button key={r.id} type="button" onClick={() => { onPick(r); setQ(''); }} className="w-full text-left px-3 py-2 border-b border-slate-50 last:border-b-0 hover:bg-slate-50" data-testid={`cal-search-result-${r.ref}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <strong className="text-[color:var(--mv-navy)]">#{r.ref}</strong>
                <span className="text-slate-700 truncate">{r.name || '—'}</span>
                <span className={`text-[9px] font-black uppercase px-1.5 py-0.5 rounded ${STATUS_CLS[r.status]}`}>{r.status}</span>
                <span className="ml-auto font-black text-[color:var(--mv-navy)]">£{r.price}</span>
              </div>
              <div className="text-xs text-slate-500 truncate">{r.phone || '—'} · {r.from_postcode || '—'} → {r.to_postcode || '—'} · {r.service}</div>
              <BookingLine r={r} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
